import { plainToClass } from 'class-transformer';
import { validateSync } from 'class-validator';
import { StylesConfigDto } from '@builder4/shared/dto/styles/StylesConfigDto';
import { formatValidationErrors, type ValidationResult } from '@builder4/shared/utils/validators';

/**
 * Validates a styles configuration object against the StylesConfigDto schema.
 * Validation is performed synchronously so that the style can be validated before
 * rendering a page in a synchronous manner.
 *
 * @param data - The styles configuration object to validate
 * @returns ValidationResult with isValid flag, detailed errors, and formatted error messages
 *
 * @example
 * const result = validateStylesConfig(myStylesData);
 * if (!result.isValid) {
 *   console.error('Validation failed:', result.errorMessages);
 * }
 */
export function validateStylesConfig(data: unknown): ValidationResult {
  const dto = plainToClass(StylesConfigDto, data);

  const errors = validateSync(dto, {
    whitelist: false, // allow unknown properties
    forbidNonWhitelisted: false,
  });

  const errorMessages = formatValidationErrors(errors);

  return {
    isValid: errors.length === 0,
    errors,
    errorMessages,
  };
}
